import { FormEvent, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { toast } from 'react-toastify'

import styles from './dump-section.module.scss'

interface IDumpSectionProps {
    downloadRequest: () => void
    uploadRequest: (file: FormData) => void
    title: string
}

function DumpSection(props: IDumpSectionProps) {
    const { downloadRequest, uploadRequest, title } = props

    const { t } = useTranslation()

    const [files, setFiles] = useState<FileList | null>(null)

    const handleFormSubmit = (e: FormEvent<HTMLFormElement>) => {
        e.preventDefault()
        if (!files) {
            toast(() => t('no_file'))
            return
        }

        const defaultFile = files[0]

        const formData = new FormData()
        formData.append('upload_file', defaultFile)

        uploadRequest(formData)
    }

    return (
        <div className={styles.dumpSection}>
            <h3 className={styles.dumpSection__title}>{title}</h3>
            <button
                className={styles.dumpSection__btn}
                onClick={downloadRequest}
            >
                {t('download')}
            </button>
            <form
                className={styles.dumpSection__form}
                onSubmit={handleFormSubmit}
                encType="multipart/form-data"
            >
                <input
                    className={styles.dumpSection__input}
                    type="file"
                    onChange={(e) => setFiles(e.target.files)}
                    name="upload_file"
                />
                <button className={styles.dumpSection__btn} type="submit">
                    {t('upload')}
                </button>
            </form>
        </div>
    )
}

export default DumpSection
